import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    TestentityService,
    TestentityPopupService,
    TestentityComponent,
    TestentityDetailComponent,
    TestentityDialogComponent,
    TestentityPopupComponent,
    TestentityDeletePopupComponent,
    TestentityDeleteDialogComponent,
    testentityRoute,
    testentityPopupRoute,
} from './';

const ENTITY_STATES = [
    ...testentityRoute,
    ...testentityPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        TestentityComponent,
        TestentityDetailComponent,
        TestentityDialogComponent,
        TestentityDeleteDialogComponent,
        TestentityPopupComponent,
        TestentityDeletePopupComponent,
    ],
    entryComponents: [
        TestentityComponent,
        TestentityDialogComponent,
        TestentityPopupComponent,
        TestentityDeleteDialogComponent,
        TestentityDeletePopupComponent,
    ],
    providers: [
        TestentityService,
        TestentityPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerTestentityModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/testentity/testentity.module.ts